// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"SectionMenu-module--scrollContainer--1p8Du"};